import { SVGIconProps } from './types'

export const WorkflowBlockIcon = (props: SVGIconProps) => {
  return (
    <svg
      width="15"
      height="15"
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 2H2.5C2.22386 2 2 2.22386 2 2.5V5.5C2 5.77614 2.22386 6 2.5 6H5.5C5.77614 6 6 5.77614 6 5.5V2.5C6 2.22386 5.77614 2 5.5 2ZM2.5 1C1.67157 1 1 1.67157 1 2.5V5.5C1 6.32843 1.67157 7 2.5 7H5.5C6.32843 7 7 6.32843 7 5.5V2.5C7 1.67157 6.32843 1 5.5 1H2.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 6V9.5C4.5 10.0523 4.94772 10.5 5.5 10.5H9V11.5H5.5C4.39543 11.5 3.5 10.6046 3.5 9.5V6H4.5Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.5 9H9.5C9.22386 9 9 9.22386 9 9.5V12.5C9 12.7761 9.22386 13 9.5 13H12.5C12.7761 13 13 12.7761 13 12.5V9.5C13 9.22386 12.7761 9 12.5 9ZM9.5 8C8.67157 8 8 8.67157 8 9.5V12.5C8 13.3284 8.67157 14 9.5 14H12.5C13.3284 14 14 13.3284 14 12.5V9.5C14 8.67157 13.3284 8 12.5 8H9.5Z"
        fill="currentColor"
      />
    </svg>
  )
}
